import { AgendaItem, AgendaItemType } from 'modules/jogador/agenda/types';

export const AGENDA_TYPE_LABELS: Record<AgendaItemType, string> = {
  jogo: 'Jogo',
  aula: 'Aula',
  torneio: 'Torneio',
};

export const MY_AGENDA_ITEMS: AgendaItem[] = [
  {
    id: 'racha-areia-3',
    type: 'jogo',
    title: 'Racha nível B · Areia 3',
    meta: 'Arena Praia Norte · 3/4 vagas',
    dateLabel: 'hoje',
    timeLabel: 'em 2h',
    status: 'confirmado',
    cancellable: false,
    cancellationNote: 'Fora do prazo de cancelamento (até 24h antes)',
  },
  {
    id: 'turma-b-ter',
    type: 'aula',
    title: 'Turma B · 2x semana',
    meta: 'Areia 2 · Prof. Camila',
    dateLabel: 'ter 17',
    timeLabel: '07:00',
    status: 'confirmado',
    cancellable: true,
    cancellationNote: 'Cancelável até 16 set',
  },
  {
    id: 'turma-b-qui',
    type: 'aula',
    title: 'Turma B · 2x semana',
    meta: 'Areia 2 · Prof. Camila',
    dateLabel: 'qui 19',
    timeLabel: '07:00',
    status: 'confirmado',
    cancellable: true,
    cancellationNote: 'Cancelável até 18 set',
  },
  {
    id: 'open-praia-norte',
    type: 'torneio',
    title: 'Open Praia Norte · Mista C',
    meta: 'Arena Praia Norte · com Rafael Nunes',
    dateLabel: 'sáb 28',
    timeLabel: '08:00',
    status: 'confirmado',
    cancellable: true,
    cancellationNote: 'Cancelável até 21 set',
  },
];
